var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3580_7301)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 58.7944C80 62.7739 66.7925 66.0001 50.4996 66.0001C34.2067 66.0001 21 62.7747 21 58.7944V41.6606H80V58.7952V58.7944Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9981 48.8188C80.0228 49.4715 79.6829 50.0988 79.2402 50.5858C78.789 51.077 78.2434 51.4693 77.6809 51.8236C76.5422 52.5134 75.3135 53.0435 74.0644 53.4941C71.5534 54.37 68.9566 54.972 66.3437 55.4218C61.1118 56.3315 55.8001 56.6688 50.4994 56.6925C45.1996 56.6696 39.8879 56.3331 34.656 55.4234C32.0422 54.9728 29.4454 54.3709 26.9344 53.4958C25.6853 53.0452 24.4566 52.5143 23.3179 51.8236C22.7563 51.4693 22.2099 51.077 21.7587 50.5858C21.3159 50.0988 20.9769 49.4715 21.0007 48.8188C21.05 49.4707 21.4392 50.0236 21.9082 50.4446C22.379 50.8767 22.9313 51.2148 23.5015 51.5141C24.6554 52.0966 25.8909 52.5202 27.1452 52.866C29.6527 53.5745 32.2343 54.0276 34.8243 54.381C37.4185 54.7183 40.0264 54.9754 42.6427 55.114C45.2565 55.2772 47.878 55.3448 50.4986 55.3406C55.7398 55.3431 60.9852 55.0675 66.1729 54.3827C68.7637 54.0285 71.3461 53.5753 73.8528 52.8677C75.107 52.5219 76.3417 52.0975 77.4965 51.5158C78.0667 51.2165 78.6199 50.8783 79.0898 50.4463C79.5588 50.0244 79.948 49.4715 79.9973 48.8197",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5 41.5168C79.5 42.2734 78.8876 43.1324 77.4237 44.0143C75.9907 44.8776 73.8838 45.6728 71.2362 46.3474C65.9486 47.6947 58.6169 48.5337 50.4996 48.5337C42.3823 48.5337 35.0508 47.6947 29.7634 46.3474C27.1159 45.6728 25.0091 44.8776 23.5761 44.0143C22.1123 43.1324 21.5 42.2734 21.5 41.5168C21.5 40.7603 22.1124 39.9012 23.5762 39.0194C25.0093 38.1561 27.1162 37.3609 29.7637 36.6863C35.0512 35.3389 42.3827 34.5 50.4996 34.5C58.6165 34.5 65.9481 35.3387 71.2359 36.6859C73.8835 37.3605 75.9905 38.1557 77.4236 39.019C78.8875 39.9009 79.5 40.7601 79.5 41.5168Z",
    fill: "white",
    stroke: "#7BA0C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3580_7301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 32,
    fill: "white",
    transform: "translate(21 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeSample);
export default __webpack_public_path__ + "static/media/free_sample.ad055c922c6cdc48b2ff5c1b3e33c1c9.svg";
export { ForwardRef as ReactComponent };